import { useState } from 'react';
import { useTheme } from '../context/theme';
import { api } from '../utils/api';
import { N, COLORS } from '../utils/constants';
import { Btn, Inp, Avatar } from './ui';

export default function Onboard({ user, onDone }) {
  const { theme, isDark } = useTheme();
  const [name, sN] = useState(user.name || '');
  const [title, sT] = useState('');
  const [phone, sPh] = useState('');
  const [pw, sPw] = useState('');
  const [color, sC] = useState(user.avatar_color || N);
  const [err, sErr] = useState('');

  const go = async () => {
    sErr('');
    try {
      await api.post('/api/auth/onboard', { name, title, phone, newPassword: pw || undefined, avatar_color: color });
      onDone();
    } catch (e) { sErr(e.message); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div className="su" style={{
        background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 20,
        padding: '40px 32px', boxShadow: '0 2px 12px rgba(0,0,0,0.4)', width: '100%', maxWidth: 440
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Avatar name={name} color={color} sz={64} />
          <h2 style={{ fontSize: 28, fontWeight: 800, color: '#FFFFFF', marginTop: 12, lineHeight: 1.2 }}>Welcome to Lightning Partners HQ</h2>
          <p style={{ color: 'rgba(255,255,255,0.58)', fontSize: 13 }}>Set up your profile to get started</p>
        </div>
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Your Name</label>
        <Inp value={name} onChange={x => sN(x.target.value)} style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Job Title</label>
        <Inp value={title} onChange={x => sT(x.target.value)} placeholder="e.g. Project Manager" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>Phone (optional)</label>
        <Inp value={phone} onChange={x => sPh(x.target.value)} placeholder="555-123-4567" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.58)', marginBottom: 5, textTransform: 'uppercase', letterSpacing: 1, fontWeight: 500 }}>New Password (min 8 chars)</label>
        <Inp type="password" value={pw} onChange={x => sPw(x.target.value)} placeholder="Set your own password" style={{ marginBottom: 12 }} />
        <label style={{ display: 'block', fontSize: 14, color: 'rgba(255,255,255,0.58)', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 1 }}>Profile Color</label>
        <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
          {COLORS.map(c => (
            <div key={c} className="color-swatch" onClick={() => sC(c)} style={{
              width: 28, height: 28, borderRadius: 8, background: c, cursor: 'pointer',
              border: color === c ? '2px solid #fff' : '2px solid transparent', transition: 'border .15s'
            }} />
          ))}
        </div>
        {err && <div style={{ color: '#EF4444', fontSize: 14, marginBottom: 10 }}>{err}</div>}
        <Btn primary full onClick={go} style={{ padding: 14, fontSize: 14 }}>Complete Setup</Btn>
      </div>
    </div>
  );
}
